import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { ExternalLink, ShoppingBag, Anchor } from 'lucide-react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

export default function GearPage() {
  // Products array - easily add more products here
  const products = [
    {
      id: 1,
      name: "3D Sailors Bail Bonds Splash Down T-Shirt",
      description: "Premium quality t-shirt featuring our dramatic 3D anchor design with turbulent ocean waves",
      price: "$22.20",
      image: "/assets/images/Image_12-2-25_at_1.09_PM-1764709808212.png",
      zazzleUrl: "https://www.zazzle.com/3d_sailors_bail_bonds_splash_down_t_shirt-256194444483941559",
      category: "Apparel"
    },
    {
      id: 2,
      name: "Anchor Wave Design T-Shirt",
      description: "Classic anchor wave design t-shirt perfect for showing your support",
      price: "$21.04",
      image: "/assets/images/Image_12-2-25_at_1.12_PM-1764710020504.png",
      zazzleUrl: "https://www.zazzle.com/anchor_wave_design_t_shirt-256055531640210006",
      category: "Apparel"
    },
    {
      id: 3,
      name: "Mermaid Anchor Hoodie",
      description: "Cozy hoodie featuring our exclusive mermaid anchor design",
      price: "$54.44",
      image: "/assets/images/Image_12-2-25_at_1.36_PM-1764711598582.png",
      zazzleUrl: "https://www.zazzle.com/mermaid_anchor_hoodie-256872478767357006",
      category: "Apparel"
    },
    {
      id: 4,
      name: "Octopus Lighthouse Hoodie Design",
      description: "Striking hoodie featuring an artistic octopus wrapped around a lighthouse, combining maritime heritage with modern nautical style",
      price: "$54.44",
      image: "/assets/images/Image_12-2-25_at_2.30_PM-1764794110519.png",
      zazzleUrl: "https://www.zazzle.com/octopus_lighthouse_hoodie_design-256429135833723497",
      category: "Apparel"
    },
    {
      id: 5,
      name: "Eagle Break-Out Women\'s T-Shirt",
      description: "Women\'s tri-blend t-shirt featuring powerful spread-winged eagle design with Sailors Bail Bonds branding and \'24/7 Bail Bonds\' messaging. Includes contact information and license details.",
      price: "$27.08",
      image: "/assets/images/Image_12-2-25_at_2.50_PM-1764716265213.png",
      zazzleUrl: "https://www.zazzle.com/eagle_break_out_womens_t_shirt_tri_blend_shirt-256702796339839625",
      category: "Apparel"
    },
    {
      id: 6,
      name: "Huge Gorilla Men\'s T-Shirt",
      description: "Bold men's t-shirt featuring a powerful gorilla standing among iconic Sacramento landmarks including the Tower Bridge. Includes Sailors Bail Bonds branding, contact information, and license number.",
      price: "$22.20",
      image: "/assets/images/Image_12-3-25_at_8.27_AM-1764779288624.png",
      zazzleUrl: "https://www.zazzle.com/huge_gorilla_t_shirt-256257585392447494",
      category: "Apparel"
    },
    {
      id: 7,
      name: "King Gorilla Engages Leo T-Shirt",
      description: "Orange rust colored men's t-shirt featuring dramatic back design with King Kong-style gorilla holding helicopters above Sacramento Tower Bridge. Includes Sailors Bail Bonds contact information (916)256-3468 and license CA LIC# 1N13041.",
      price: "$22.20",
      image: "/assets/images/Image_12-3-25_at_9.35_AM-1764783394657.png",
      zazzleUrl: "https://www.zazzle.com/king_gorilla_engages_leo_t_shirt-256586122873808190",
      category: "Apparel"
    },
    {
      id: 8,
      name: "Enraged King Gorilla Cresting the Tower Bridge Women\'s T-Shirt",
      description: "Women's t-shirt featuring dramatic back design with large King Kong-style gorilla holding helicopter above Sacramento Tower Bridge. Includes Sailors Bail Bonds branding, contact information (916)256-3468, and license number CA LIC# 1N13041.",
      price: "$21.36",
      image: "/assets/images/Image_12-3-25_at_10.46_AM-1764787618401.png",
      zazzleUrl: "https://www.zazzle.com/enraged_king_gorilla_cresting_the_tower_bridge_t_shirt-256949726043584144",
      category: "Apparel"
    },
    {
      id: 9,
      name: "Sea Monster Battles the US Navy",
      description: "Men's t-shirt featuring dramatic back design with large sea monster/octopus tentacles emerging from water, attacking military ships and aircraft with explosions. Includes Sailors Bail Bonds branding, contact information (916)256-3468, and license CA LIC# 1N13041.",
      price: "$22.20",
      image: "/assets/images/Image_12-3-25_at_12.25_PM-1764793553070.png",
      zazzleUrl: "https://www.zazzle.com/sea_monster_battles_the_us_navy_t_shirt-256860620428325378",
      category: "Apparel"
    },
    {
      id: 10,
      name: "UFO Invasion in SF Bay - US Navy Responds",
      description: "Men's t-shirt featuring dramatic back design with UFO invasion over San Francisco Bay showing Golden Gate Bridge, multiple flying saucers with laser beams, US Navy ships responding with explosions and combat. Includes Sailors Bail Bonds branding, contact information (916)256-3468, license CA LIC# 1N13041, and website SAILORSBAIL.COM.",
      price: "$22.20",
      image: "/assets/images/Image_12-3-25_at_1.01_PM-1764796062561.png",
      zazzleUrl: "https://www.zazzle.com/ufos_attack_us_navy_in_san_francisco_bay_t_shirt-256720326934698525",
      category: "Apparel"
    },
    {
      id: 11,
      name: "Freeway Pile Up T-Shirt Design",
      description: "Black men's t-shirt featuring dramatic emergency response scene with freeway pile up including burning big rig truck, multiple crashed cars, emergency responders performing CPR, law enforcement officers rescuing people, and helicopters overhead including lifeflight landing. Includes Sailors Bail Bonds branding, contact information (916)256-3468, license CA LIC# 1N13041, and website SAILORSBAIL.COM.",
      price: "$22.20",
      image: "/assets/images/Image_12-3-25_at_1.49_PM-1764798589529.png",
      zazzleUrl: "https://www.zazzle.com/freeway_pile_up_t_shirt_design-256955067850652090",
      category: "Apparel"
    }
    // Add more products here in the same format
  ];

  const [selectedCategory, setSelectedCategory] = useState('all');

  // Get unique categories
  const categories = ['all', ...new Set(products.map(p => p.category))];

  // Filter products by category
  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products?.filter(p => p?.category === selectedCategory);

  return (
    <>
      <Helmet>
        <title>Gear - Sailors Bail Bonds Merchandise | sailorsbail.com</title>
        <meta 
          name="description" 
          content="Shop official Sailors Bail Bonds branded merchandise including t-shirts, hoodies, and accessories. Show your support with quality gear from Sacramento's trusted bail bond service." 
        />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
        <Header />
        
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white py-20">
          <div className="absolute inset-0 bg-[url('/anchor-pattern.png')] opacity-5"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <div className="flex justify-center mb-6">
                <ShoppingBag className="w-16 h-16 text-yellow-400" />
              </div>
              <h1 className="text-5xl font-bold mb-4">
                Sailors Bail Bonds Gear
              </h1>
              <p className="text-xl text-blue-100 mb-2">
                Official Branded Merchandise
              </p>
              <p className="text-lg text-blue-200">
                Show your support with quality apparel and accessories
              </p>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
          <div className="container mx-auto px-4 py-4">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories?.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full font-medium transition-all ${
                    selectedCategory === category
                      ? 'bg-blue-900 text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category?.charAt(0)?.toUpperCase() + category?.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            {filteredProducts?.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">No products found in this category.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                {filteredProducts?.map((product) => (
                  <div
                    key={product?.id}
                    className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 border border-gray-100"
                  >
                    {/* Product Image */}
                    <div className="relative h-80 bg-gradient-to-br from-blue-50 to-gray-50 flex items-center justify-center">
                      {product?.image === "/placeholder-tshirt.jpg" ? (
                        <div className="text-center p-8">
                          <Anchor className="w-24 h-24 text-blue-900 mx-auto mb-4" />
                          <p className="text-gray-500 text-sm">Product Image Coming Soon</p>
                        </div>
                      ) : (
                        <img
                          src={product?.image}
                          alt={product?.name}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="absolute top-4 right-4 bg-yellow-400 text-blue-900 px-3 py-1 rounded-full font-bold text-sm">
                        {product?.price}
                      </div>
                    </div>

                    {/* Product Info */}
                    <div className="p-6">
                      <div className="mb-2">
                        <span className="inline-block bg-blue-100 text-blue-900 text-xs font-semibold px-3 py-1 rounded-full">
                          {product?.category}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {product?.name}
                      </h3>
                      <p className="text-gray-600 mb-4 line-clamp-2">
                        {product?.description}
                      </p>

                      {/* Shop Button */}
                      <a
                        href={product?.zazzleUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full bg-gradient-to-r from-blue-900 to-blue-800 hover:from-blue-800 hover:to-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-all duration-300 text-center shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                      >
                        <ShoppingBag className="w-5 h-5" />
                        Shop on Zazzle
                        <ExternalLink className="w-4 h-4" />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Info Section */}
        <section className="bg-blue-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                About Our Merchandise
              </h2>
              <p className="text-gray-700 mb-4">
                All Sailors Bail Bonds merchandise is available through our official Zazzle store. 
                When you click "Shop on Zazzle," you'll be taken to our trusted partner where you can 
                complete your purchase securely.
              </p>
              <p className="text-gray-600 text-sm">
                Products are printed on-demand with high-quality materials. 
                Check back regularly for new designs and merchandise!
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}